// extracted by mini-css-extract-plugin
module.exports = {"search":"TradesWidget_search__2X9ay","card":"TradesWidget_card__375sh"};